module.exports = __webpack_public_path__ + "static/img/avatar.632ffa96.png";